import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('factoryItem', 'factoryItems');

const customActions = {
  async LOAD_factoryItems({ rootGetters, commit }) {
    const data = await odata.o(rootGetters)
      .get('factoryItems')
      .query({
        $filter: 'IsDeleted eq false',
        $orderby: 'created desc',
        $expand: 'Brand,StockItem',
      });
    commit('SET_factoryItems', data);
    return data;
  },
};

export default { ...actions, ...customActions };
